export default __webpack_public_path__ + "static/media/41_mobile.8fdb40c1.jpg";